export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          刃牙漫画独家专题
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          精选刃牙漫画全系列篇章，下拉式阅读，一滑到底
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {/* Card 1 - featured span 2 cols */}
          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer lg:col-span-2 lg:flex">
            <div className="relative overflow-hidden lg:w-[45%] flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Intense%20manga%20style%20illustration%20of%20muscular%20fighter%20silhouette%20in%20combat%20stance%2C%20dramatic%20red%20and%20black%20ink%20wash%20background%2C%20Japanese%20comic%20aesthetic%2C%20bold%20brush%20strokes%2C%20dynamic%20action%20composition%2C%20warm%20lighting%2C%20no%20text&width=800&height=500&seq=card-01&orientation=landscape"
                alt="刃牙道"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                热门连载
              </span>
            </div>
            <div className="p-5 lg:flex-1 lg:flex lg:flex-col lg:justify-center">
              <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-2">刃牙道</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">地下格斗王者范马刃牙，踏上挑战史上最强生物——父亲范马勇次郎的巅峰之路。极致肌肉碰撞，热血沸腾的格斗盛宴。</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20illustration%20of%20young%20fighter%20in%20dynamic%20action%20pose%20with%20speed%20lines%2C%20warm%20amber%20and%20crimson%20background%2C%20Japanese%20comic%20style%2C%20dramatic%20shadows%2C%20intense%20atmosphere%2C%20no%20text&width=800&height=500&seq=card-02&orientation=landscape"
                alt="范马刃牙"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-secondary-500 text-white text-xs font-medium whitespace-nowrap">
                经典全集
              </span>
            </div>
            <div className="p-5">
              <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-2">范马刃牙</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">刃牙系列正传篇章，讲述少年范马刃牙在地下竞技场一路成长，面对各路强敌，不断突破极限的传奇故事。</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20style%20character%20silhouette%20with%20dramatic%20backlighting%2C%20warm%20orange%20and%20dark%20background%2C%20ink%20brush%20effect%2C%20Japanese%20comic%20aesthetic%2C%20powerful%20stance%2C%20atmospheric%20mood%2C%20no%20text&width=800&height=500&seq=card-03&orientation=landscape"
                alt="刃牙外传"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium whitespace-nowrap">
                番外合集
              </span>
            </div>
            <div className="p-5">
              <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-2">刃牙外传</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">收录刃牙系列全部外传与番外篇章，包括烈海王异世界、花山薰外传等精彩内容，补全刃牙宇宙的每一个角落。</p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Martial%20arts%20tournament%20manga%20style%20illustration%2C%20arena%20silhouette%20with%20dramatic%20lighting%2C%20warm%20red%20and%20amber%20tones%2C%20Japanese%20comic%20aesthetic%2C%20epic%20scale%2C%20crowd%20energy%2C%20no%20text&width=800&height=500&seq=card-04&orientation=landscape"
                alt="刃牙大擂台"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                精华篇章
              </span>
            </div>
            <div className="p-5">
              <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-2">刃牙大擂台</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">中国大擂台赛篇完整收录，刃牙与来自世界各地的顶尖格斗家同台竞技，东西方格斗技的激烈碰撞与融合。</p>
            </div>
          </div>

          {/* Card 5 */}
          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20with%20manga%20panel%20overlay%2C%20warm%20crimson%20and%20dark%20background%2C%20Japanese%20comic%20aesthetic%2C%20dynamic%20visual%20split%20composition%2C%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=card-05&orientation=landscape"
                alt="刃牙动画联动"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-secondary-500 text-white text-xs font-medium whitespace-nowrap">
                动画专题
              </span>
            </div>
            <div className="p-5">
              <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-2">刃牙动画联动</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">刃牙动画化作品全记录，TV动画、OVA、剧场版一应俱全，同步漫画剧情深度解析与对比赏析。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}